module.exports = __webpack_public_path__ + "static/media/Loan.739b1184.svg";